export const DATE_FORMAT = "DD/MM/YYYY";
export const DATE_DISPLAY_FORMAT = "DD MMM YYYY";
export const TIME_DISPLAY_FORMAT = "hh:mm a";

export const STANDARD_DATE_FORMAT = 'YYYY-MM-DD';